module.exports = __webpack_public_path__ + "static/media/Basal_3872.73630a8f.jpg";